import React from 'react'
import PropTypes from 'prop-types'
import { formatPrice } from 'helpers/utils'
import * as UI from './Common.styles'

const Service = ({ className, iconName, name, price, url }) =>
  <UI.Block className={ className } data-at-globalsearch-service>
    <UI.Table>
      <UI.CustomServiceIcon data-at-globalsearch-service-icon iconName={ iconName } />
      <UI.Info>
        <UI.Name data-at-globalsearch-service-name to={ url }>{ name }</UI.Name>
        {
          price &&
            <UI.Price data-at-globalsearch-service-price>{ formatPrice(price) }</UI.Price>
        }
      </UI.Info>
    </UI.Table>
  </UI.Block>

Service.propTypes = {
  className: PropTypes.string,
  iconName: PropTypes.string,
  name: PropTypes.string,
  price: PropTypes.number,
  url: PropTypes.string
}

export default Service
